import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bsd2pg2itm: FaireBrandEntity = {
  token: "b_bsd2pg2itm",
  type: "brand",
  name: "Novelty Brands",
  avatarUrl:
    "https://cdn.faire.com/fastly/9cc9b32716e5582cd1b46a1e7eec825c01a3eef7bbf40dbaf563aefa04e1a67c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/628b4e2e842d329aa02398a0fb3efc5b0bc0c3359bf1712e2bc1f61f094d3d9e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/9cc9b32716e5582cd1b46a1e7eec825c01a3eef7bbf40dbaf563aefa04e1a67c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/628b4e2e842d329aa02398a0fb3efc5b0bc0c3359bf1712e2bc1f61f094d3d9e.png",
  location: "Greenfield, IN, USA",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 722,
  isInsider: true,
  description:
    "Novelty Inc Brands is a world leader and direct importer of novelty items, variety goods, smoking accessories, and the top trending products for impulse buys. Our commitment to staying ahead and creating trends mixed with our core values of quality, integrity, and good ole’ fashioned customer service has kept us extremely competitive in the industry.\n\nOur in-house trend analysis experts, product development team and art department combine to analyze the trends in unique products before they hit the shelves. Since we have offices in China, we can offer deeper discounts, more affordable shipping, and the most comprehensive customization in the industry.\n\nIt is our mission to provide the hottest insights on trending products that deliver high profitability and customer satisfaction. Customers get what they want, when they want, at the most competitive prices around the globe.\n",
  meta: {
    source: "api",
    importedAt: "2026-07-17T18:40:35.325Z",
    importedBy: "entity-db-cli",
  },
};
